import { Box } from "@prismicio/editor-ui"
import type { PropsWithChildren, ReactNode } from "react"

import { routeAnimationDuration } from "../app/routing"

export const headerHeight = 72
export const headerBottomMargin = 24
export const sidePanelWidth = 280
export const mainContentMaxWidth = 1330

interface DocumentLayoutProps {
  header: ReactNode
  main: ReactNode
}

export function DocumentLayout(props: DocumentLayoutProps) {
  const { header, main } = props

  return (
    <Box
      display="grid"
      alignItems="center"
      width="100%"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
    >
      <Box justifyContent="center">
        <Box
          position="relative"
          top={headerHeight}
          maxWidth={mainContentMaxWidth}
          width="100%"
        >
          {main}
        </Box>
      </Box>
      {header}
    </Box>
  )
}

export function SidePanel(props: PropsWithChildren) {
  const { children } = props

  return (
    <Box
      as="nav"
      position="sticky"
      top={headerHeight}
      gap={16}
      width={sidePanelWidth}
      flexShrink={0}
      maxHeight={`calc(100vh - ${headerHeight}px)`}
      flexDirection="column"
    >
      {children}
    </Box>
  )
}

// Assign good looking paddings in case the internal content has a scrollbar
export function sidePanelPadding(side: "left" | "right") {
  switch (side) {
    // 2px on the left so that the selected indicator is not cut by the overflow.
    case "left":
      return { left: 2, right: 24, bottom: 8 } as const
    // 2px on the right so that the selected indicator is not cut by the overflow.
    // 100px at the bottom so that the AnimatedList doesn't cut the content while it's animating.
    case "right":
      return { left: 24, right: 2, bottom: 100 } as const
  }
}
